'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createInstantSearch;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InstantSearch = require('../components/InstantSearch');

var _InstantSearch2 = _interopRequireDefault(_InstantSearch);

var _version = require('./version');

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a specialized root InstantSearch component. It accepts
 * an algolia client and a specification of the root Element.
 * @param {function} defaultAlgoliaClient - a function that builds an Algolia client
 * @param {object} root - the defininition of the root of an InstantSearch sub tree.
 * @returns {object} an InstantSearch root
 */
function createInstantSearch(defaultAlgoliaClient, root) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(CreateInstantSearch, _Component);

    function CreateInstantSearch() {
      var _ref;

      _classCallCheck(this, CreateInstantSearch);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = CreateInstantSearch.__proto__ || Object.getPrototypeOf(CreateInstantSearch)).call.apply(_ref, [this].concat(args)));

      if (_this.props.searchClient) {
        if (_this.props.appId || _this.props.apiKey || _this.props.algoliaClient) {
          throw new Error('react-instantsearch:: `searchClient` cannot be used with `appId`, `apiKey` or `algoliaClient`.');
        }
      }

      if (_this.props.algoliaClient) {
        // eslint-disable-next-line no-console
        console.warn('`algoliaClient` option was renamed `searchClient`. Please use this new option before the next major version.');
      }

      _this.client = _this.props.searchClient || _this.props.algoliaClient || defaultAlgoliaClient(_this.props.appId, _this.props.apiKey, {
        _useRequestCache: true
      });

      if (typeof _this.client.addAlgoliaAgent === 'function') {
        _this.client.addAlgoliaAgent('react-instantsearch ' + _version2.default);
      }
      return _this;
    }

    _createClass(CreateInstantSearch, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var props = this.props;

        if (nextProps.searchClient) {
          this.client = nextProps.searchClient;
        } else if (nextProps.algoliaClient) {
          this.client = nextProps.algoliaClient;
        } else if (props.appId !== nextProps.appId || props.apiKey !== nextProps.apiKey) {
          this.client = defaultAlgoliaClient(nextProps.appId, nextProps.apiKey);
        }

        if (typeof this.client.addAlgoliaAgent === 'function') {
          this.client.addAlgoliaAgent('react-instantsearch ' + _version2.default);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          _InstantSearch2.default,
          {
            createURL: this.props.createURL,
            indexName: this.props.indexName,
            searchState: this.props.searchState,
            onSearchStateChange: this.props.onSearchStateChange,
            onSearchParameters: this.props.onSearchParameters,
            root: this.props.root,
            searchClient: this.client,
            algoliaClient: this.client,
            refresh: this.props.refresh,
            resultsState: this.props.resultsState
          },
          this.props.children
        );
      }
    }]);

    return CreateInstantSearch;
  }(_react.Component), _class.propTypes = {
    algoliaClient: _propTypes2.default.object,
    searchClient: _propTypes2.default.object,
    appId: _propTypes2.default.string,
    apiKey: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    indexName: _propTypes2.default.string.isRequired,
    createURL: _propTypes2.default.func,
    searchState: _propTypes2.default.object,
    refresh: _propTypes2.default.bool.isRequired,
    onSearchStateChange: _propTypes2.default.func,
    onSearchParameters: _propTypes2.default.func,
    resultsState: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    root: _propTypes2.default.shape({
      Root: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
      props: _propTypes2.default.object
    })
  }, _class.defaultProps = {
    refresh: false,
    root: root
  }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/createInstantSearch.js
// module id = 973
// module chunks = 142807904292071